import * as React from 'react'
import { Block } from 'baseui/block';  
import { ISensorDigital } from './types'

export const ConfigurationPanel = (props: ISensorDigital) => {

    return (
        <>
        <Block gridRowGap='20px' display='flex' flexDirection='column' >
        </Block>
        </>
    )
}
